import classnames from "classnames";
import React from "react";
import Icon from "../../../../components/Icon";
import SpacingBox from "../../../../components/SpacingBox";
import { WaveInverse } from "../../../../components/Wave";
import { browser } from "../../../../libs/helpers/browser";
import IntroBenefits from "./IntroBenefits";
import IntroSectionProvider from "./IntroSectionProvider";
import IntroPrice from "./intro-price";
import "./newStyles.css";
import useIntroSection from "../../hooks/use-intro-section";
import useIntroSectionBanner from "../../hooks/use-intro-section-banner";

import arrowsMore from '../../../../assets/images/icons/arrows-more.svg'

import hogarLogo from '../../../../assets/images/landing/hogar-flex.webp'
const IntroBannerImage = React.memo(() => {
    const {
        activePromotionDone,
        hasPromotion,
        introAsset,
        setLoadedBanner,
    } = useIntroSectionBanner();

    return (
        activePromotionDone && (
            <div
                id="landing-intro__banner-img"
                data-testid="intro__banner-img"
                className={classnames("landing-intro__banner-img", {
                    "landing-intro__banner-img--promotion": hasPromotion,
                })}
            >
                <img
                    title="familia"
                    src={introAsset}
                    alt="Intro familia"
                    onLoad={() => setLoadedBanner(true)}
                />
            </div>
        )
    );
});

const IntroSection = () => {
    const { isMobile, hasPromotion, handleClickLandingButton } = useIntroSection();

    const bannerRender = (
        <div data-testid="intro-section" className="landing-intro__container">
            <div
                className={classnames("landing-intro", {
                    "landing-intro--promotion": hasPromotion,
                })}
            >
                <img
                    alt="hogar logo"
                    title="hogar logo"
                    className="landing-intro__logo"
                    src={hogarLogo}
                />
                <IntroBannerImage />
                {isMobile ? (
                    <IntroPrice imageWidth={100} hasPromotion={hasPromotion} />
                ) : (
                    <IntroPrice hasPromotion={hasPromotion} />
                )}
                <div
                    data-testid="action-button-landing"
                    className="landing-intro__more"
                    onClick={handleClickLandingButton}
                >
                    <span>Conoce más</span>
                    <Icon width={isMobile ? 12 : 20} name="arrows-more" image={arrowsMore} />
                </div>
                <div className="landing-intro__bottom-wave">
                    <WaveInverse />
                </div>
            </div>
            <SpacingBox mt="15">
                <IntroBenefits />
            </SpacingBox>
        </div>
    );

    return <IntroSectionProvider>{bannerRender}</IntroSectionProvider>;
};

export default React.memo(IntroSection);
